var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 60,
    viewBox: "0 0 107 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2192_1030)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.252 4.50072L5.4105 22.2682C1.18296 26.4782 1.18296 33.304 5.4105 37.514L23.252 55.2815C27.4795 59.4915 34.3337 59.4915 38.5613 55.2815L56.4027 37.514C60.6303 33.304 60.6303 26.4782 56.4027 22.2682L38.5613 4.50072C34.3337 0.290714 27.4795 0.290712 23.252 4.50072Z",
    stroke: "#C94B32",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.252 4.50072L5.4105 22.2682C1.18296 26.4782 1.18296 33.304 5.4105 37.514L23.252 55.2815C27.4795 59.4915 34.3337 59.4915 38.5613 55.2815L56.4027 37.514C60.6303 33.304 60.6303 26.4782 56.4027 22.2682L38.5613 4.50072C34.3337 0.290714 27.4795 0.290712 23.252 4.50072Z",
    stroke: "#C94B32",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0791 22.6497V37.1596C21.0791 38.5579 22.2173 39.6914 23.6214 39.6914H38.1918C39.5959 39.6914 40.7341 38.5579 40.7341 37.1596V22.6497C40.7341 21.2514 39.5959 20.1179 38.1918 20.1179H23.6214C22.2173 20.1179 21.0791 21.2514 21.0791 22.6497Z",
    stroke: "#C94B32",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6846 16.6608C55.4958 7.62267 65.0636 1.47021 76.0529 1.47021C91.9082 1.47021 104.756 14.2651 104.756 30.0546C104.756 45.8441 91.9082 58.639 76.0529 58.639C65.0636 58.639 55.4958 52.4866 50.6846 43.4484",
    stroke: "#C94B32",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.2984 35.2542C81.2957 35.2542 85.3468 31.2199 85.3468 26.2433C85.3468 21.2667 81.2957 17.2324 76.2984 17.2324C71.3011 17.2324 67.25 21.2667 67.25 26.2433C67.25 31.2199 71.3011 35.2542 76.2984 35.2542Z",
    stroke: "#C94B32",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.3266 54.8549C88.3266 48.1036 82.8319 42.6045 76.0251 42.6045C69.2183 42.6045 63.7236 48.0764 63.7236 54.8549",
    stroke: "#C94B32",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2192_1030"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 105.246,
    height: 60,
    fill: "white",
    transform: "translate(0.876953)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPt);
export default __webpack_public_path__ + "static/media/PT.799fbd3f824d1df99c14cc9376385597.svg";
export { ForwardRef as ReactComponent };